import { fill } from 'lodash';
import BaseModel from './BaseModel';

export default class CellModel extends BaseModel {

    constructor({ symbol = 'bonus', type = 'regular', highlight = false, slotIndex, cellIndex } = {})
    {
        super();

        this.setProperty('symbol', symbol);
        this.setProperty('type', type);
        this.setProperty('highlight', highlight);
        this.setProperty('slotIndex', slotIndex);
        this.setProperty('cellIndex', cellIndex);

        switch (type)
        {
            case 'regular':
                {
                    this.setProperty('cells', 1);

                    let highlightFrames = [];
                    for (let i = 0; i < 20; i++)
                    {
                        highlightFrames.push(i);
                    }
                    this.setProperty('highlightFrames', highlightFrames);
                }
                break;

            case 'extra':
                {
                    this.setProperty('cells', 3);

                    let transformFrames = [];
                    for (let i = 0; i < 39; i++)
                    {
                        transformFrames.push(i);
                    }
                    this.setProperty('transformFrames', transformFrames);

                    let wildFrames = [];
                    for (let i = 40; i < 59; i++)
                    {
                        wildFrames.push(i);
                    }
                    this.setProperty('wildFrames', wildFrames);

                    let scatterFrames = [];
                    for (let i = 60; i < 80; i++)
                    {
                        scatterFrames.push(i);
                    }
                    this.setProperty('scatterFrames', scatterFrames);
                }
                break;

            default:
                throw new Error('Unsupported cell type.');
        }
    }

    compare(model)
    {
        return this === model || (this.slotIndex === model.slotIndex && this.cellIndex === model.cellIndex);
    }

    toString()
    {
        return `[object CellModel] slotIndex=${this.slotIndex}, cellIndex=${this.cellIndex}, symbol=${this.symbol}`;
    }

    get slotIndex()
    {
        return this.getProperty('slotIndex');
    }

    get cellIndex()
    {
        return this.getProperty('cellIndex');
    }

    set cellIndex(value)
    {
        this.setProperty('cellIndex', value);
    }

    get symbol()
    {
        return this.getProperty('symbol');
    }

    set symbol(value)
    {
        this.setProperty('symbol', value);
    }

    get type()
    {
        return this.getProperty('type');
    }

    get highlight()
    {
        return this.getProperty('highlight');
    }

    set highlight(value)
    {
        this.setProperty('highlight', value);
    }

    get cells()
    {
        return this.getProperty('cells');
    }

    get transformFrames()
    {
        return this.getProperty('transformFrames');
    }

    get highlightFrames()
    {
        return this.getProperty('highlightFrames');
    }

    get wildFrames()
    {
        return this.getProperty('wildFrames');
    }

    get scatterFrames()
    {
        return this.getProperty('scatterFrames');
    }
}
